import { getEvents } from '@/services/webApi';
import { EventsQueryInput } from '@goodneighbor/api/schemas/events/index';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

export default function useEventsQuery(
  query: EventsQueryInput,
  enabled = true
) {
  return useQuery({
    queryKey: ['events', query],
    retry: false,
    enabled,
    queryFn: () => getEvents(query),
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5,
    placeholderData: keepPreviousData
  });
}
